import { render } from "./jndxPrescriptionPayments.vue?vue&type=template&id=4e59f354&scoped=true"
import script from "./jndxPrescriptionPayments.vue?vue&type=script&lang=js"
export * from "./jndxPrescriptionPayments.vue?vue&type=script&lang=js"

import "./jndxPrescriptionPayments.vue?vue&type=style&index=0&id=4e59f354&lang=scss&scoped=true"

import exportComponent from "D:\\workFolder\\payment-H5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e59f354"]])

export default __exports__